import React, { useEffect, useState } from 'react';
import Destaque from '../Components/Destaque/Destaque.jsx';
import PromotionCarousel from '../Components/PromotionCarousel/PromotionCarousel.jsx';
import MedicosConsultas from '../Components/MedicosConsultas/MedicosConsultas.jsx';
import Contatos from '../Components/Contatos/Contatos.jsx';
import Localizacao from '../Components/Localizacao/Localizacao.jsx';
import clinicaConfig from "../clinicaConfig.js";
import { ClipLoader } from "react-spinners";


const Shop = () => {
  const [promotions, setPromotions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const API_BASE_URL = clinicaConfig.REACT_APP_API_BASE_URL || 'http://localhost:4000';

  useEffect(() => {
    const fetchPublicData = async () => {
      try {
        setLoading(true);
        setError(null);

        const clientDomain = window.location.hostname;
        console.log('Shop - Domínio detectado:', clientDomain);

        const headers = {
          'X-Client-Domain': clientDomain,
          'Content-Type': 'application/json'
        };

        console.log('Shop - Fazendo requisição para:', `${API_BASE_URL}/public/promotions`);
        console.log('Shop - Headers:', headers);

        const promotionsResponse = await fetch(`${API_BASE_URL}/public/promotions`, { headers });

        console.log('Shop - Status da resposta (promotions):', promotionsResponse.status);

        if (!promotionsResponse.ok) {
          throw new Error(`Erro ao buscar promoções: ${promotionsResponse.status} ${promotionsResponse.statusText}`);
        }

        const promotionsData = await promotionsResponse.json();
        console.log('Shop - Dados de promoções recebidos:', promotionsData);

        if (promotionsData.success) {
          const now = new Date();
          const activePromotions = promotionsData.promotions.filter(promo => {
            const dataFim = new Date(promo.dataFim);
            return dataFim >= now;
          });
          setPromotions(activePromotions);
          console.log('Shop - Promoções ativas carregadas:', activePromotions.length);
        } else {
          throw new Error(promotionsData.message || 'Falha ao buscar promoções.');
        }

      } catch (err) {
        console.error("Shop - Erro ao carregar dados públicos:", err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchPublicData();
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [API_BASE_URL]);

  if (loading) {
    return <div className="destaque-loading-container"><ClipLoader size={150} color="var(--primary)" /></div>;
  }

  if (error) {
    return (
      <div style={{ color: 'red', padding: '20px', textAlign: 'center' }}>
        <h3>Erro ao carregar dados: {error}</h3>
        <button
          onClick={() => window.location.reload()}
          style={{
            padding: '10px 20px',
            backgroundColor: '#007bff',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
            marginTop: '10px'
          }}
        >
          Tentar Novamente
        </button>
      </div>
    );
  }

  return (
    <div>
      <Destaque />
      {promotions.length > 0 && (
        <PromotionCarousel promotions={promotions} />
      )}
      <MedicosConsultas />
      <Contatos />
      <Localizacao />
    </div>
  );
};

export default Shop;